export enum TutorialHotspot {
  // Campaigns
  manageCampaign = "manage-campaign",
  createCampaignBtn = "create-campaign-btn",
  filterCampaignItems = "filter-campaign-items",
  paginationAndDisplay = "pagination-and-display",
  
  //Flight plans
  createFlightPlan = "create-flight-plan",
  enterFPTaCSId = "enter-TaCS-id",
  nameFlightPlan = "name-flight-plan",
  enterFPDates = "enter-FP-dates",
  addFPNotes = "enter-FP-notes",

  //Default
  defaultContent = "default-content",
}

export const DOWNLOADABLE_TUTORIAL_URL = "https://w.amazon.com/bin/view/MODE/Data_Technology/Products/TaCS"; //Placeholder until tutorial content is ready
export const MODE_WIKI_URL = "https://w.amazon.com/bin/view/MODE/";
export const TaCS_WIKI_URL = "https://w.amazon.com/bin/view/MODE/Data_Technology/Products/TaCS";
export const TUTORIALS_COMPLETED = "tutorialsCompleted";
